import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './store/store.js'
import App from './App.jsx'
import './assets/css/index.css'

// Performance optimizations
import { preloadResource } from './utils/performance'

// Предзагружаем критические ресурсы
if (typeof window !== 'undefined') {
  // Предзагружаем шрифты
  preloadResource('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap', 'font', 'anonymous')

  
  // Предзагружаем API эндпоинты для главной страницы
  preloadResource('/api/profile', 'fetch')
  preloadResource('/api/skills', 'fetch')
}

const root = ReactDOM.createRoot(document.getElementById('root'))

// Оптимизированный рендер с обработкой ошибок
try {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  )
} catch (error) {
  console.error('Failed to render app:', error)
  
  // Fallback UI при критической ошибке
  root.render(
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: 'system-ui, sans-serif',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div>
        <h1>Произошла ошибка</h1>
        <p>Пожалуйста, перезагрузите страницу</p>
        <button 
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 20px',
            marginTop: '20px',
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          Перезагрузить
        </button>
      </div>
    </div>
  )
}